class ProductsOrderTableSettings {
  animationName: string;
  animationDuration: string;
  availabilityInfo: {
    showStatementText: boolean,
    showStatementDate: boolean,
  }
  showGroupHeadline: boolean;
  freeItemScrollOnSelect: boolean;
}
const productsOrderTableSettings = new ProductsOrderTableSettings();

productsOrderTableSettings.animationName = 'vue-animation--list';
productsOrderTableSettings.animationDuration = '.5s';
productsOrderTableSettings.availabilityInfo = {
  showStatementText: false,
  showStatementDate: false,
};
productsOrderTableSettings.showGroupHeadline = true;
productsOrderTableSettings.freeItemScrollOnSelect = false;

export {productsOrderTableSettings, ProductsOrderTableSettings};
